/**
 * @file: useLockScreenOrientation.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useIsHub } from '@euler/functions/isHub';
import { sentry } from '@euler/lib/integration/sentry';
import { useEffect } from 'react';
import { constrainScreenOrientationIfNeeded } from './constrainScreenOrientationIfNeeded';

export const useLockScreenOrientation = () => {
  const isHub = useIsHub();
  useEffect(() => {
    constrainScreenOrientationIfNeeded(isHub).catch(error => {
      sentry.captureException(error);
    });
  }, [isHub]);
};
